/**
 * Налаштування джерел для ГОСТЯ (без входу). Залогінені зберігають їх на сервері (в акаунті),
 * а в гостя акаунта немає — тож вони лежать у localStorage браузера й разом із кожним запитом
 * до /api/plugins/<id>/… їдуть заголовком X-Source-Prefs (див. src/auth.ts → attachUser).
 * Модуль навмисно не імпортує api.ts/auth.ts (вони самі його використовують).
 */
const KEY_PREFIX = 'lnr-source-prefs:';
const AUTH_HINT_KEY = 'lnr-auth-hint'; // той самий ключ, що в auth.ts

/** Чи вважати поточного відвідувача гостем (за підказкою auth.ts; невідомо — гість). */
export function isGuestHint(): boolean {
  try {
    return localStorage.getItem(AUTH_HINT_KEY) !== 'user';
  } catch {
    return true;
  }
}

export function getGuestPrefs(pluginId: string): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + pluginId);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function setGuestPrefs(pluginId: string, values: Record<string, unknown>): void {
  try {
    localStorage.setItem(KEY_PREFIX + pluginId, JSON.stringify(values));
  } catch {
    /* сховище недоступне (приватний режим тощо) — налаштування діятимуть до перезавантаження */
  }
}

/** Заголовок X-Source-Prefs для запиту до /api/plugins/<id>/…, якщо гість щось зберіг для цього джерела. */
export function guestPrefsHeaders(url: string): Record<string, string> {
  const m = url.match(/^\/api\/plugins\/([^/?]+)\//);
  if (!m || !isGuestHint()) return {};
  const prefs = getGuestPrefs(decodeURIComponent(m[1]));
  if (!prefs) return {};
  const value = encodeURIComponent(JSON.stringify({ [decodeURIComponent(m[1])]: prefs }));
  return value.length <= 8000 ? { 'X-Source-Prefs': value } : {};
}
